import { computed, ref } from 'vue';
import { useStore } from 'vuex';

export function useUserForm(data = null) {
  const {
    formValues = ref(),
    regionSelectionNecessary = ref(false),
  } = data || {};

  const isSending = ref(false);
  const message = ref(null);

  const store = useStore();

  const user = computed(() => store.state.user.activeUser);
  const isValidated = computed(() => store.getters['user/isValidated']);

  const contactRegions = computed(() => store.state.generic.contactRegions);
  const formSecurityToken = computed(() => store.state.generic.formSecurityToken);
  const links = computed(() => store.state.generic.links);

  const consentHintNecessary = computed(() => !(user.value
    && user.value.consent
    && Array.isArray(user.value.consent)
    && user.value.consent.indexOf('inquiries') > -1));

  const hasMessage = computed(() => message.value && message.value.content);

  const selectedRegion = computed(() => {
    if (formValues.value && formValues.value.region) {
      return contactRegions.value.find((r) => r.code === formValues.value.region);
    }

    return null;
  });

  const selectedSubRegion = computed(() => {
    if (selectedRegion.value
      && selectedRegion.value.subRegions
      && formValues.value.subRegion) {
      return selectedRegion.value.subRegions.find((r) => r.code === formValues.value.subRegion);
    }

    return null;
  });

  const fullRegionLabel = computed(() => {
    if (!regionSelectionNecessary.value || !selectedRegion.value) return null;

    let label = selectedRegion.value.title;

    if (selectedSubRegion.value) {
      label += ` :: ${selectedSubRegion.value.title}`;
    }

    return label;
  });

  return {
    isSending,
    message,
    user,
    isValidated,
    contactRegions,
    formSecurityToken,
    links,
    consentHintNecessary,
    hasMessage,
    selectedRegion,
    selectedSubRegion,
    fullRegionLabel,
  };
}
